import { defineStore } from 'pinia';

export const useUtilsStore = defineStore('utilsStore', {
  state: () => {
    return {
      isPc: true,
      pcSwiper: true,
      showAlert: false,
      showProcess: false,
      tabletSwiper: false,
      mobileSwiper: false,
      isLoading: false,
      showQRcode: false,
      alert: {
        title: '',
        message: '',
        button: '',
        goToAccount: true,
        logout: false,
        closeWindow: false,
      },
      process: {
        title: 'Processing',
        assetName: 'TEST NAME',
        assetPrice: 0.1,
        priceUnit: 'WETH',
        count: 1,
        usdtPrice: 131.57,
      },
      processSwitch: {
        isStep1Processing: true,
        isStep1Finished: false,
        isStep2Processing: false,
        isStep2Finished: false,
      },
    };
  },
  actions: {
    checkDevice() {
      this.isPc = window.innerWidth >= 750 ? true : false;
      this.pcSwiper = window.innerWidth >= 1500 ? true : false;
      this.tabletSwiper =
        window.innerWidth < 1500 && window.innerWidth >= 750 ? true : false;
      this.mobileSwiper = window.innerWidth < 750 ? true : false;
    },
    switchLoading() {
      this.isLoading = !this.isLoading;
    },
    switchAlert() {
      this.showAlert = !this.showAlert;
    },
    passAlertContent(message) {
      this.alert = message;
    },
    switchProcess() {
      this.showProcess = !this.showProcess;
    },
    switchQRcode() {
      this.showQRcode = !this.showQRcode;
    },
    passProcessContent(message) {
      this.process = message;
    },
    step2Processing() {
      this.processSwitch.isStep1Processing = false;
      this.processSwitch.isStep1Finished = true;
      this.processSwitch.isStep2Processing = true;
    },
    allFinished() {
      this.processSwitch.isStep2Processing = false;
      this.processSwitch.isStep2Finished = true;
    },
    resetProcess() {
      this.processSwitch.isStep1Processing = true;
      this.processSwitch.isStep1Finished = false;
      this.processSwitch.isStep2Processing = false;
      this.processSwitch.isStep2Finished = false;
    },
  },
});
